export const homeObjOne = {
    id: 'about',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: 'About',
    headline: 'Finch',
    description: 'A team of AI software developers build, redesign, and customize AI-driven systems as part of your existing in-house team or on a turnkey basis to help you complete your project quickly and affordably.',
    buttonLabel: 'Learn More',
    imgStart: false,
    img: require('../../Images/svg-1.svg').default,
    alt: 'the tech guy',
    dark: true,
    primary: true,
    darkText: false
}

export const homeObjTwo = {
    id: 'discover',
    lightBg: true,
    lightText: false,
    lightTextDesc: false,
    topLine: 'Discover',
    headline: 'AI-Driven Software Solutions',
    description: 'Our expert team of software engineers conceptualizes and implements AI-driven software solutions into business operations to contribute to long-term business continuity and efficiency, including smart systems for data-driven decision making, marketing & sales, or customer service.',
    buttonLabel: 'Learn More',
    imgStart: true,
    img: require('../../Images/svg-2.svg').default,
    alt: 'the tech guy',
    dark: false,
    primary: false,
    darkText: true
}

export const homeObjThree = {
    id: 'signup',
    lightBg: false,
    lightText: true,
    lightTextDesc: true,
    topLine: 'Sign Up',
    headline: 'Create an account',
    description: 'We design AI-driven solutions that counteract security threats using anti-fraud ML models for fraud detection, biometric identification & recognition techniques, and theft & misuse detection methods to protect data, user identity, and physical perimeters.',
    buttonLabel: 'Get in touch',
    imgStart: false,
    img: require('../../Images/svg-3.svg').default,
    alt: 'the tech guy',
    dark: true,
    primary: true,
    darkText: false
}